import React from 'react';
import { Route, Routes } from "react-router-dom";
import Kodi from './Components/Kodi';
import Analyze from './Components/Competitive'
import Translate from './Components/Translate';
import TranslateJSON from './Components/TranslateJSON'
import Wordmark from './Components/Wordmark';
import TranslateSheet from './Components/TranslateSheet';
// import Glossary from './Components/Glossary';

function App() {
  return (
      <Routes>
        <Route  path="/" element={<Kodi />} />
        <Route  path="/competitive" element={<Analyze />} />
        <Route  path="/translate" element={<Translate />} />
        <Route  path="/TranslateJSON" element={<TranslateJSON />} />
        <Route  path="/wordmark" element={<Wordmark />} />
        <Route  path="/translate-sheet" element={<TranslateSheet />} />
      </Routes>
  );
}

export default App;